import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-login-section',
  templateUrl: './login-section.component.html',
  styleUrls: ['./login-section.component.scss']
})
export class LoginSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
